import store from "store";
import FirebaseService from "./FirebaseService";
import { onUserLogOut } from "store/slices/userSlice";
import { cleanCache } from "store/slices/cacheSlice";

const AuthService = {};

AuthService.login = async (data) => {
	return FirebaseService.signInEmailRequest(...Object.values(data));
};

AuthService.logout = async () => {
	store.dispatch(cleanCache());
	store.dispatch(onUserLogOut());
	return FirebaseService.signOutRequest();
};

export default AuthService;
